import React, { useEffect, useState } from 'react'
import { StyledText, Button } from '@clickcease/cc-client-components-lib'
import {
  MultiDomainsContainer,
  AddDomainsWrapper,
  AddDomainsTopLIne,
} from './NewMultipleDomains.styles'
import { SelectOption } from 'Types/Option'
import { AddDomainsInput } from './components/AddDomainsInput'
import { useTranslation } from 'react-i18next'
import { StringMap } from 'i18next'
import { combineAndRemoveDuplicates, MAX_DOMAINS } from './helpers'
import { ManageAddedDomains } from './components/ManageAddedDomains'
import { useAllowedLimits } from 'Hooks/useAllowedLimits'
import { ToasterMessage } from './components/ToasterMessages/ToasterMessages'
import useAddDomainStore from './store/addDomainsStore'
import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'

export const NewMultipleDomains = () => {
  const { t } = useTranslation('domainManagement')
  const { selectedDomains, setProductsLeft, setDomainsLeft, setAllowedProducts } =
    useAddDomainStore()
  const [newDomains, setNewDomains] = useState<SelectOption[]>([])
  const [domains, setDomains] = useState<SelectOption[]>([])

  const { domainsLeft: productsLeftsFromHook } = useAllowedLimits()
  const { data: packagesData } = useGetPackagingLimits()

  // initialize the domains store
  useEffect(() => {
    const pmAllowed = Boolean(packagesData?.paidMarketingDomainsLimit)
    const bmAllowed = Boolean(packagesData?.botZappingDomainsLimit)
    const productsLeft = {
      botZapping:
        productsLeftsFromHook.botZapping -
        selectedDomains.filter((domain) => domain.botZapping).length,
      paidMarketing:
        productsLeftsFromHook.paidMarketing -
        selectedDomains.filter((domain) => domain.paidMarketing).length,
    }

    setAllowedProducts({
      paidMarketing: pmAllowed,
      botZapping: bmAllowed,
    })
    setProductsLeft(productsLeft)
    setDomainsLeft(
      (bmAllowed ? productsLeft.botZapping : 0) + (pmAllowed ? productsLeft.paidMarketing : 0)
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsLeftsFromHook.paidMarketing, productsLeftsFromHook.botZapping, selectedDomains])

  const translate = (key: string, options?: StringMap): string =>
    t(`add_new_multiple_domains_modal.${key}`, options)

  const handleAddDomain = (domains: SelectOption[]) => {
    setDomains((prev: SelectOption[]) => combineAndRemoveDuplicates(prev, domains))
    setNewDomains([])
  }

  const disableButton = !newDomains.length || newDomains.length > MAX_DOMAINS

  return (
    <MultiDomainsContainer>
      {/* Toaster */}
      {<ToasterMessage />}

      {/* Add Domains Part */}
      <AddDomainsWrapper>
        <AddDomainsTopLIne>
          <StyledText variant={'baseBold'}>{translate('input_title')}</StyledText>
          {newDomains.length > 1 && (
            <Button
              variant="ghost"
              text={translate('clear_all_button')}
              onClick={() => setNewDomains([])}
            />
          )}
        </AddDomainsTopLIne>
        <AddDomainsInput domains={newDomains} setDomains={setNewDomains} />
        <Button
          disabled={disableButton}
          variant="outline"
          text={translate('input_button')}
          onClick={() => handleAddDomain(newDomains)}
        />
      </AddDomainsWrapper>

      {/* Set domain the correct product part */}
      <ManageAddedDomains domains={domains} />
    </MultiDomainsContainer>
  )
}
